"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreWithUserPhoneNumberSchema = exports.StoreSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const base_store_1 = require("./base-store");
exports.StoreSchema = __1.BaseStoreSchema.extend({
    owner: zod_1.z.lazy(() => __1.UserWithoutStoreSchema.or(__1.UserWithoutStoreSchema.partial().required({ id: true }))),
    currentContract: zod_1.z
        .lazy(() => __1.ContractWithoutStoreSchema.or(__1.ContractWithoutStoreSchema.partial().required({ id: true })))
        .optional(),
    billingAddress: __1.AddressSchema.optional(),
    companyAddress: __1.AddressSchema.optional(),
    socialNetworkUris: base_store_1.SocialNetworkUrisSchema.omit({ other: true }).optional(),
    paymentMethodsOffered: base_store_1.PaymentMethodsOfferedSchema.optional(),
    shippingSettings: base_store_1.ShippingSettingsSchema.optional(),
});
exports.StoreWithUserPhoneNumberSchema = exports.StoreSchema.pick({
    id: true,
    currency: true,
    owner: true,
})
    .required({ owner: true })
    .extend({
    owner: __1.UserWithoutStoreSchema.pick({ phoneNumber: true, id: true }).required({ phoneNumber: true }),
});
//# sourceMappingURL=store.js.map